// extracted by mini-css-extract-plugin
export var dividerLine = "_91-3";
export var itemImage = "_91-9";
export var lightDivider = "_91-4";
export var modalContent = "_91-5";
export var modalContentCompact = "_91-6";
export var productCard = "_91-a";
export var productImage = "_91-b";
export var productImageCompact = "_91-7";
export var productImagePlaceholder = "_91-c";
export var productImagePlaceholderCompact = "_91-8";
export var progressBarBackground = "_91-1";
export var progressBarContainer = "_91-0";
export var progressBarFill = "_91-2";